import React from 'react';
import {useSelector} from 'react-redux';
import TutorialModal from '../TutorialModal/TutorialModal';
import {selectTutorialActiveModalId} from '../../../redux/reducers/privateStateReducer/selectors';
import {getTutorialBarbaReplica, TUTORIAL_SPEAKERS} from '../../../configs/tutorial/tutorialBarbaReplicas';
import {PRIMARY_COLOR} from '../../../styles/constants';
import './BarbaReplicaModal.css';

// Вырезан из barba_tutorial.jpg (белый фон): на темном затемнении модалки
// белый квадрат выглядел бы заплатой
export const BARBA_PORTRAIT_SRC = '/img/campaign/barba_tutorial.png';
// Голова с того же портрета (кадр 276×276 от верхнего края) — медальон на
// плашке задания: задания дает он же
export const BARBA_AVATAR_SRC = '/img/campaign/barba_tutorial_avatar.png';

/**
 * Окно реплики Барбы в начале и в конце главы обучения (тексты —
 * configs/tutorial/tutorialBarbaReplicas). Закрытие — обычная кнопка
 * TutorialModal: шаг главы, метрика modal_closed, запись прохождения.
 *
 * Один компонент на все окна (в реестре все chN_barba_M указывают сюда):
 * между окнами цепочки React не пересоздает модалку — портрет остается на
 * месте, меняются только текст и кнопка.
 *
 * Портрет — в оверлее модалки, поверх затемнения и окна (раскладка —
 * BarbaReplicaModal.css), клики сквозь него проходят. Рамки окна — всегда в
 * основном цвете, а не в цвете ходящего игрока, как у прочих модалок: это
 * голос наставника, а не ход партии.
 */
const BarbaReplicaModal = () => {
  const activeModalId = useSelector(selectTutorialActiveModalId);
  const replica = getTutorialBarbaReplica(activeModalId);

  if (!replica) {
    return null;
  }

  return (
    <TutorialModal
      title={'Барба'}
      buttonText={replica.buttonText}
      className={'barba-replica-modal'}
      overlayClassName={'barba-replica-overlay'}
      borderColor={PRIMARY_COLOR}
      overlayContent={(
        <div className={'barba-replica-portrait'} aria-hidden={'true'}>
          <img className={'barba-replica-portrait_image'} src={BARBA_PORTRAIT_SRC} alt={''}/>
        </div>
      )}
    >
      {/* key: текст следующего окна проявляется заново */}
      <div key={activeModalId} className={'barba-replica-modal_replica'}>
        {replica.paragraphs.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </div>
    </TutorialModal>
  );
};

/**
 * Первое окно Барбы и плашка задания открываются в момент появления поля —
 * портрет и медальон грузим заранее, пока глава загружается, иначе они
 * появились бы позже текста
 *
 * @param {Object|null} chapter - конфиг главы
 */
export const preloadBarbaPortrait = (chapter) => {
  if (typeof Image === 'undefined') {
    return;
  }
  if ((chapter?.steps || []).some((step) => step.speaker === TUTORIAL_SPEAKERS.BARBA)) {
    new Image().src = BARBA_PORTRAIT_SRC;
    new Image().src = BARBA_AVATAR_SRC;
  }
};

export default BarbaReplicaModal;
